export default __webpack_public_path__ + "static/media/medical_3.7defb243.jpg";